// BM-H4878 (Vanessa, 29 Oct 2026): a golden rule step on an older matter that
// CaseMinder cannot find in the matter's SharePoint folder links to the
// compliance step itself, so it can be put right. "we do NOT want either
// route minting new matter refs": the conflict step therefore has no link.
// A new conflict check opens a new matter number and folder (BL.HD.002.1569),
// so the conflict step is remediated in the steps panel with reasons.

// Pipeline Tracker stage -> golden rule step (hub/pre_cm_history.py STEPS).
export const PRE_CM_STEP_FOR_STAGE = {
  conflict: "conflict",
  ob_sent: "ob",
  ob_returned: "ob",
  aml_check: "aml",
  forf_draft: "forf_ra",
  ccl_draft: "ccl",
  ccl_signed: "ccl",
};

export const PRE_CM_CONFLICT_NOTE =
  "Do not start a new conflict check: it opens a new matter number. Record the search you ran, and its result, as the reasons.";

// The live screen for a step, or null for the conflict step. `ccl: true`
// means open it through openMatterCcl (there is no synchronous CCL URL).
export function remediationLink(step, matterRef) {
  if (!matterRef) return null;
  const ref = encodeURIComponent(matterRef);
  switch (step) {
    case "ob":
      return { label: "Open the matter to send onboarding", path: `/matter/${ref}` };
    case "aml":
      return { label: "Open AML / Thirdfort", path: `/matter/${ref}#thirdfort-review` };
    case "forf_ra":
      return { label: "Open the FORF and risk assessment", path: `/forf/${ref}` };
    case "ccl":
      return { label: "Open the client care letter", ccl: true };
    default:
      return null;
  }
}

// Whether CaseMinder found a file for the step in the matter folder.
// "found", "missing", or "unknown" (the folder could not be read).
export function folderState(found, step) {
  if (!found || !found.available) return "unknown";
  return (found.suggestions?.[step] || []).length ? "found" : "missing";
}
